import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';

import NDACheckbox from 'project/components/nda_checkbox';
import { updateAutoNDA } from 'project/ducks/project';

export function mapStateToProps({ project }) {
  const { nda_auto_approve } = project.projectPage.project.data;
  return {
    checked: nda_auto_approve,
  };
}


export function mapDispatchToProps(dispatch, { projectId }) {
  return bindActionCreators({
    updateAutoNDA: partial(updateAutoNDA, projectId),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NDACheckbox);



// WEBPACK FOOTER //
// ./project/containers/nda_checkbox.js